const STALE_TIME = 5 * 60 * 1000;

export const requests = {
  key: "platformNotification",
  checkBlobStoreTokens: async (companyId: number | undefined) => {
    const { default: databases } = await import("@/api/database.api");
    const response = await databases.v1.data.checkBlobStoreTokenStatus(companyId);
    return response.data;
  },
  checkApiTokens: async (companyId: number | undefined) => {
    const { default: apiTokens } = await import("@/api/token.api");
    const response = await apiTokens.v1.checkApiTokenStatus(companyId);
    return response.data;
  },
};

export const queries = {
  getBlobstoreTokenWarnings: (companyId: number | undefined) => ({
    queryKey: [requests.key, "blobstore-tokens", companyId],
    queryFn: () => requests.checkBlobStoreTokens(companyId),
    enabled: companyId !== undefined,
    staleTime: STALE_TIME,
    retry: false,
    throwOnError: false,
  }),

  getApiTokenWarnings: (companyId: number | undefined) => ({
    queryKey: [requests.key, "api-tokens", companyId] as const,
    queryFn: () => requests.checkApiTokens(companyId),
    enabled: companyId !== undefined,
    staleTime: STALE_TIME,
    retry: false,
    throwOnError: false,
  }),
};
